import { useRef, useState } from 'react';
import { Icon } from './Icon.js';

/**
 * The one file picker (UI review, 3 October 2026: media, lead lists, contacts and documents each had
 * their own). A box with Choose file, the name of what was chosen, and room to drop a file on it.
 * The caller keeps the file; the native input is emptied after every pick, so choosing the same file
 * again still fires.
 */
export function FileField({ id, accept, fileName, onFile, disabled, ariaLabel }: {
  id?: string;
  accept?: string | undefined;
  /** What is chosen now, or nothing. */
  fileName?: string | null | undefined;
  onFile: (file: File) => void;
  disabled?: boolean;
  /** When there is no visible label pointing at `id`. */
  ariaLabel?: string;
}) {
  const input = useRef<HTMLInputElement | null>(null);
  const [over, setOver] = useState(false);
  const take = (f: File | undefined) => { if (f && !disabled) onFile(f); };
  return (
    <div className="arc-file" data-over={over} data-disabled={disabled ?? false}
      onDragOver={(e) => { e.preventDefault(); if (!disabled) setOver(true); }}
      onDragLeave={() => setOver(false)}
      onDrop={(e) => { e.preventDefault(); setOver(false); take(e.dataTransfer.files?.[0]); }}>
      <button type="button" className="arc-btn arc-btn-sm" disabled={disabled} onClick={() => input.current?.click()}>
        <Icon name="upload" size={13} /> Choose file
      </button>
      <span className={fileName ? 'arc-file-name' : 'arc-file-name arc-subtle'}>{fileName ?? 'or drop one here'}</span>
      <input id={id} ref={input} type="file" hidden accept={accept} disabled={disabled} aria-label={ariaLabel}
        onChange={(e) => { take(e.target.files?.[0]); e.target.value = ''; }} />
    </div>
  );
}
